#import "../fragments/booking-fragment.graphql"

mutation CancelBooking($input: BookingCancelInput!) {
    bookingCancel(input: $input) {
        booking {
            ...BookingFragment
        }
    }
}
